// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { PropsWithChildren } from 'https://esm.sh/react@18';

type LayoutInternalProps = {
  logo: string;
  appName: string;
  appUrl: string;
};
export function LayoutInternal({ children, logo, appUrl, appName }: PropsWithChildren<LayoutInternalProps>) {
  return (
    <html
      dir="ltr"
      lang="en"
      style={{
        height: '100%',
      }}
    >
      <head></head>
      <body
        style={{
          margin: 0,
          padding: '32px 0px',
          boxSizing: 'border-box',
          backgroundColor: '#f9fafb',
          color: '#242424',
        }}
      >
        <table
          align="center"
          width="100%"
          style={{
            fontFamily: 'Inter, sans-serif',
            boxSizing: 'inherit',
            backgroundColor: '#FFFFFF',
            maxWidth: '600px',
            minHeight: '48px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          }}
          role="presentation"
          cellSpacing="0"
          cellPadding="0"
          border={0}
          bgcolor="#FFFFFF"
        >
          <tbody
            style={{
              boxSizing: 'inherit',
            }}
          >
            <tr
              style={{
                boxSizing: 'inherit',
                width: '100%',
              }}
            >
              <td
                style={{
                  boxSizing: 'inherit',
                }}
              >
                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          boxSizing: 'content-box',
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          padding: '40px 40px 0px 40px',
                        }}
                        valign="middle"
                      >
                        <a href={appUrl} target="_blank">
                          <img
                            src={logo}
                            alt="logo"
                            style={{
                              maxWidth: '370px',
                              maxHeight: '40px',
                              margin: '0px auto',
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          padding: '40px',
                        }}
                      >
                        {children}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr
                  style={{
                    boxSizing: 'inherit',
                    margin: '0px',
                    width: '100%',
                    border: 'none',
                    borderTop: '1px solid #eaeaea',
                    borderColor: 'rgb(233, 233, 233)',
                    borderTopWidth: '1px',
                  }}
                />

                <table
                  align="center"
                  width="100%"
                  cellPadding="0"
                  border={0}
                  style={{
                    boxSizing: 'inherit',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody
                    style={{
                      boxSizing: 'inherit',
                      width: '100%',
                    }}
                  >
                    <tr
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <td
                        style={{
                          color: '#474849',
                          fontSize: '12px',
                          fontWeight: 'normal',
                          padding: '24px 40px 24px 40px',
                          textAlign: 'center',
                          maxWidth: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        <p
                          style={{
                            boxSizing: 'inherit',
                            marginTop: '0px',
                            marginBottom: '0px',
                          }}
                        >
                          Gympera © {new Date().getFullYear()}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
  );
}

function Layout({ children }: PropsWithChildren) {
  return (
    <LayoutInternal
      appName={Deno.env.get('APP_NAME') ?? ''}
      appUrl={Deno.env.get('FRONTEND_APP_URL') ?? ''}
      logo={`${Deno.env.get('FRONTEND_APP_URL')}/images/logo-reverse-text.png`}
    >
      {children}
    </LayoutInternal>
  );
}

export default Layout;
